module.exports = __webpack_public_path__ + "static/img/8.e281630d.png";